export default {
  errorIntegerNumber: "Number must be integer",
};
